import { useState } from "react";

interface FilterGroup {
  key: string;
  label: string;
  options: readonly string[];
}

interface FilterBarProps {
  groups: FilterGroup[];
  values: Record<string, string>;
  onChange: (key: string, value: string) => void;
}

export default function FilterBar({ groups, values, onChange }: FilterBarProps) {
  const [open, setOpen] = useState(false);

  const renderGroup = (group: FilterGroup) => (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
      <span className="shrink-0 text-sm text-foreground-500 sm:w-14">{group.label}</span>
      <div className="flex flex-wrap gap-2">
        {group.options.map((opt) => {
          const active = values[group.key] === opt;
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onChange(group.key, opt)}
              className={`px-3 py-1.5 rounded-full text-xs whitespace-nowrap transition-colors cursor-pointer ${
                active
                  ? "bg-accent-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:text-foreground-950 border border-background-200"
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className="rounded-lg bg-background-100 border border-background-200/70 p-4 md:p-5">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex sm:hidden w-full items-center justify-between text-sm text-foreground-800 cursor-pointer"
      >
        <span className="flex items-center gap-2">
          <i className="ri-filter-3-line text-accent-500 text-lg"></i>
          筛选条件
        </span>
        <i className={open ? "ri-arrow-up-s-line text-lg" : "ri-arrow-down-s-line text-lg"}></i>
      </button>

      <div className={`${open ? "flex" : "hidden"} sm:flex flex-col gap-4 mt-4 sm:mt-0`}>
        {groups.map((group) => (
          <div key={group.key}>{renderGroup(group)}</div>
        ))}
      </div>
    </div>
  );
}